<div class="page-container">
<div class="card p-3 m-3">
  <div class="row px-3 mb-2">
    <div class="statistics mb-2 d-flex align-items-end gap-3">
      <a href="/statistics" class="statistics-link d-flex align-items-center gap-2">
        <h2 class="mb-0">
          <b style="color: black;">KPI colli</b>
        </h2>
        <i class="fas fa-reply return-icon"></i>
      </a>      <div class="ms-auto">
        
      </div>
    </div>


    <!-- FILTRI IN RIGA -->
    <form (ngSubmit)="onSubmit()">

      <div class="d-flex flex-wrap gap-3 mb-3">
        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredClients.length > 1">
          <label class="form-label">Clienti</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown
              *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
              name="clients"
              [placeholder]="'Seleziona clienti'"
              [settings]="dropdownSettingsClient"
              [data]="filteredClients"
              [(ngModel)]="selectedClients"
              [ngModelOptions]="{standalone: true}"
              (onSelect)="onClientsChange()"
              (onDeSelect)="onClientsChange()"
              (onSelectAll)="selectAllClients()"
              (onDeSelectAll)="deselectAllClients()"
            >
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredBrands.length > 1">
          <label class="form-label">Marchi</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
              name="brands"
              [placeholder]="'Seleziona marchi'"
              [settings]="dropdownSettingsBrand"
              [data]="filteredBrands"
              [(ngModel)]="selectedBrands"
              [ngModelOptions]="{standalone: true}"
              >
            </ng-multiselect-dropdown>
          </div>
        </div>

        <div class="mb-2 d-flex">
          <div class="filter-item" style="min-width: 180px;">
            <label style="padding-left:30px;" class="form-label d-block">Intervallo da</label>
            <div class="d-flex align-items-center">
              <button class="date-nav-btn" type="button" (click)="decrementStartDate(); decrementEndDate()" title="Giorno precedente">
                <i class="fa fa-chevron-left"></i>
              </button>
              <input type="date" class="form-control" [(ngModel)]="dateStart" name="dateStart">

            </div>
          </div>

          <div class="filter-item" style="min-width: 180px;">
            <label class="form-label">Intervallo a</label>
            <div class="d-flex align-items-center">
              <input type="date" class="form-control" [(ngModel)]="dateEnd" name="dateEnd">
              <button class="date-nav-btn" type="button" (click)="incrementStartDate(); incrementEndDate()" title="Giorno successivo">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="mb-2 d-flex">
          <div class="filter-item" style="min-width: 180px;">
            <label style="padding-left:30px;" class="form-label d-block">Max consegna da</label>
            <div class="d-flex align-items-center">
              <button class="date-nav-btn" type="button" (click)="decrementStartEstimatedDate(); decrementEndEstimatedDate()" title="Giorno precedente">
                <i class="fa fa-chevron-left"></i>
              </button>
              <input type="date" class="form-control" [(ngModel)]="estimatedDateStart" name="estimatedDateStart">

            </div>
          </div>

          <div class="filter-item" style="min-width: 180px;">
            <label class="form-label">Max consegna a</label>
            <div class="d-flex align-items-center">
              <input type="date" class="form-control" [(ngModel)]="estimatedDateEnd" name="estimatedDateEnd">
              <button class="date-nav-btn" type="button" (click)="incrementStartEstimatedDate(); incrementEndEstimatedDate()" title="Giorno successivo">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- MACROZONE -->
        <div class="filter-item" style="min-width: 200px;" *ngIf="zones?.length">
          <label class="form-label">Macrozona</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown
              *ngIf="zones.length > 0 && dropdownSettingsZone"
              name="zones"
              [placeholder]="'Seleziona macrozone'"
              [settings]="dropdownSettingsZone"
              [data]="zones"
              [(ngModel)]="selectedZones"
              [ngModelOptions]="{standalone: true}"
              (onSelect)="onZonesChange()"
              (onDeSelect)="onZonesChange()"
              (onSelectAll)="selectAllZones()"
              (onDeSelectAll)="deselectAllZones()"
            >
            </ng-multiselect-dropdown>
          </div>
        </div>

        <!-- REGIONI -->
        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredRegions?.length">
          <label class="form-label">Zona</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown
              *ngIf="filteredRegions.length > 0 && dropdownSettingsRegion"
              name="regions"
              [placeholder]="'Seleziona zone'"
              [settings]="dropdownSettingsRegion"
              [data]="filteredRegions"
              [(ngModel)]="selectedRegions"
              [ngModelOptions]="{standalone: true}"
            >
            </ng-multiselect-dropdown>
          </div>
        </div>


      </div>      <!-- BOTTONE FILTRA + RESET IN RIGA A DESTRA -->
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-filter"></i>
          Applica Filtri
        </button>
        <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
      </div>

    </form>
  </div>
</div>


  <!-- LOADING -->
  <div *ngIf="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p>Caricamento dati...</p>
  </div>

  <!-- ERRORE -->
  <div *ngIf="error" class="alert alert-danger text-center">
    {{ error }}
  </div>  <div class="row px-3 mb-3">
    <div class="col-12 d-flex align-items-center justify-content-end gap-2 flex-wrap flex-md-nowrap">      
      <!-- <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-hash"></i></span>
        <input type="text" class="form-control" [value]="totalItems" readonly style="max-width: 80px;">
      </div>

      <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-view-list"></i></span>
        <select class="form-select" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let size of [5, 10, 25, 50, 100]" [value]="size">{{size}}</option>
        </select>
      </div> -->
      
      <button class="btn btn-green w-auto"
              type="button"
              (click)="exportStatisticsToExcel()"
              title="Esporta Excel">
        <i class="fas fa-file-excel"></i>
      </button>
      
    </div>
  </div>
  <!-- RISULTATI -->
  <div *ngIf="stats && !loading" class="row mx-3">
    <div class="card table-container p-0">
      <div class="card-body p-0">
        <div class="table-responsive">
        
            <table class="table table-bordered text-center">
              <thead class="table-light align-middle text-nowrap">
                <tr>
                  <th>#</th>
                  <th (click)="setSort('macrozona')" style="cursor:pointer">
                    Macrozona
                    <i class="bi" [ngClass]="{
                      'bi-arrow-down': sortState.active === 'macrozona' && sortState.direction === 'desc',
                      'bi-arrow-up': sortState.active === 'macrozona' && sortState.direction === 'asc',
                      'bi-arrow-down-up': sortState.active !== 'macrozona'
                    }"></i>
                  </th>
                  <th (click)="setSort('zona')" style="cursor:pointer">
                    Zona
                    <i class="bi" [ngClass]="{
                      'bi-arrow-down': sortState.active === 'zona' && sortState.direction === 'desc',
                      'bi-arrow-up': sortState.active === 'zona' && sortState.direction === 'asc',
                      'bi-arrow-down-up': sortState.active !== 'zona'
                    }"></i>
                  </th>
                  <th>Totale colli</th>
                  <th>Colli non cert.</th>
                  <th>Colli consegnati</th>
                  <th>Colli con problemi</th>
                  <th>Colli in tempo</th>
                  <th>Colli ritardo</th>
                  <th>Colli ritardo&lt;2h</th>
                  <th>Colli 2h&lt;ritardo&lt;3h</th>
                  <th>Colli 3h&lt;ritardo&lt;1d</th>
                  <th>Colli ritardo oltre 1d</th>
                  <th>Colli fuori range</th>
                  <th (click)="setSort('percentualeColliInTempo')" style="cursor:pointer">
                    % Colli in tempo
                    <i class="bi" [ngClass]="{
                      'bi-arrow-down': sortState.active === 'percentualeColliInTempo' && sortState.direction === 'desc',
                      'bi-arrow-up': sortState.active === 'percentualeColliInTempo' && sortState.direction === 'asc',
                      'bi-arrow-down-up': sortState.active !== 'percentualeColliInTempo'
                    }"></i>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let stat of getPaginatedStats(); let i = index" class="align-middle text-nowrap text-center">
                  <td>{{ pageIndex * pageSize + i + 1 }}</td>
                  <td>{{ stat.macrozona }}</td>
                  <td>{{ stat.zona }}</td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, '')">
                    {{ stat.totaleColli }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'nonConsegnati')">
                      {{ stat.colliNonCertificati }}
                    </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'consegnati')">
                    {{ stat.colliConsegnati }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'conProblemi')">
                    {{ stat.colliConProblemi }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'inTempo')">
                      {{ stat.colliInTempo }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'inRitardo')">
                      {{ stat.colliRitardo }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'inRitardoMin2h')">
                    {{ stat.colliRitardoMinore2ore }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'inRitardoMin2hMax3h')">
                    {{ stat.colliRitardoMaggiore2Minore3ore }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'inRitardoMin3hMax1d')">
                    {{ stat.colliRitardoMaggiore3Minore1giorno }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'inRitardoOltre1d')">
                    {{ stat.colliRitardoMaggiore1giorno }}
                  </td>
                  <td class="kpi-clickable"
                      (click)="openOverviewDelivered(stat, 'fuoriRange')">
                    {{ stat.colliFuoriRange }}
                  </td>
                  <td>
                    <div class="progress-bar-wrapper">
                      <div class="progress-bar-inner"
                          [ngStyle]="{
                            'width.%': stat.percentualeColliInTempo,
                            'background-color': stat.percentualeColliInTempo >= 96 ? '#90ee90' :
                                                (stat.percentualeColliInTempo >= 60 ? '#fff176' : '#f28b82')
                          }">
                      </div>
                      <span class="progress-bar-label">
                        {{ stat.percentualeColliInTempo | number:'1.0-2' }}%
                      </span>
                    </div>
                  </td>
                </tr>
                <!-- RIGA TOTALE -->
                <tr *ngIf="getTotals()" class="fw-bold table-secondary">
                  <td></td>
                  <td>Totale</td>
                  <td></td>
                  <td>{{ getTotals().totaleColli }}</td>
                  <td>{{ getTotals().colliNonCertificati }}</td>
                  <td>{{ getTotals().colliConsegnati }}</td>
                  <td>{{ getTotals().colliConProblemi }}</td>
                  <td>{{ getTotals().colliInTempo }}</td>
                  <td>{{ getTotals().colliRitardo }}</td>
                  <td>{{ getTotals().colliRitardoMinore2ore }}</td>
                  <td>{{ getTotals().colliRitardoMaggiore2Minore3ore }}</td>
                  <td>{{ getTotals().colliRitardoMaggiore3Minore1giorno }}</td>
                  <td>{{ getTotals().colliRitardoMaggiore1giorno }}</td>
                  <td>{{ getTotals().colliFuoriRange }}</td>
                  <td></td>
                </tr>

                <tr *ngIf="getPaginatedStats().length === 0">
                  <td colspan="14" class="text-center py-3">
                    Nessuna statistica trovata
                  </td>
                </tr>
              </tbody>
            </table>

        </div>
        <!-- Paginazione Bootstrap -->
        <!-- <div class="d-flex flex-column flex-md-row justify-content-end align-items-center p-2 gap-2">
          <nav aria-label="Paginazione tabella" *ngIf="totalItems > 0">
            <ul class="pagination mb-0">
              <li class="page-item" [class.disabled]="pageIndex === 0">
                <a class="page-link" href="javascript:void(0)" (click)="firstPage()">
                  <i class="bi bi-chevron-double-left"></i>
                </a>
              </li>
              <li class="page-item" [class.disabled]="pageIndex === 0">
                <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
                  <i class="bi bi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item">
                <span class="page-link">
                    Pagina {{getNumberOfPages() === 0 ? 1 : pageIndex + 1}} di
                    {{getNumberOfPages() === 0 ? 1 : getNumberOfPages()}}
                </span>
              </li>
              <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
                <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                  <i class="bi bi-chevron-right"></i>
                </a>
              </li>          <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
                <a class="page-link" href="javascript:void(0)" (click)="lastPage()">
                  <i class="bi bi-chevron-double-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div> -->
      </div>
    </div>
  </div>


  



</div>